import React, { createContext, useContext, useEffect, useState } from "react";
import api, { BACKEND_URL } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({ logo_url: "" });

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data.access_token) localStorage.setItem("mvs_access_token", data.access_token);
    if (data.refresh_token) localStorage.setItem("mvs_refresh_token", data.refresh_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("mvs_access_token");
    localStorage.removeItem("mvs_refresh_token");
    setUser(false);
  };

  const logoUrl = settings.logo_url
    ? settings.logo_url.startsWith("/") ? `${BACKEND_URL}${settings.logo_url}` : settings.logo_url
    : "";

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, logoUrl, settings, setSettings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
